import Grayscale from "./grayscale.vue";

export default Grayscale;
